import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-test-adder',
  templateUrl: './test-adder.component.html',
  styleUrls: ['./test-adder.component.css']
})
export class TestAdderComponent implements OnInit {

  @Input() a!: number;
  @Input() b!: number;

  constructor() { }

  ngOnInit(): void {
  }

}
